import React  from 'react';
import bem from 'utils/bem';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';

import logo from './images/logo_r.svg?raw';
import './index.sass';

const { cnBlock, el } = bem('logo');

export default ({className}) => {
    const { pathname } = useLocation();
    const isFront = pathname === '/';
    if (isFront) return (
        <div className={cnBlock(className)} to={'/'}>
            <div className={el('svg')} dangerouslySetInnerHTML={{__html: logo}} />
        </div>
    )
    return (
        <Link className={cnBlock(className)} to={'/'}>
            <div className={el('svg')} dangerouslySetInnerHTML={{__html: logo}} />
        </Link>
    )
}
